module.exports = __webpack_public_path__ + "img/final.20f8a8ff.svg";